<template>
  <div>
    <ScrollView
      class="DashScrollContainer"
      :refreshing="refreshing"
      @onRefresh="onRefresh"
      :empty="data.length === 0"
    >
      <div class="chart-pie d-flex align-items-center mx-4 px-4">
        <CChartPie
          :labels="labels"
          :datasets="datasets"
          :options="options"
          class="flex-grow-1"
        />
        <div class="conceptos">
          <div class="item totales">
            <i class="dot" />
            <span class="label">Total:</span>
            <span class="valor">{{ $formatter(total, moneda) }}</span>
          </div>
          <Item
            v-for="(itm, i) of conceptos"
            class="item"
            :key="`link_${i}`"
            :isSubGrafica="itm.isSubGrafica"
            :to="{
              name: 'AnalyticsChart',
              params: { ...itm.subGrafica, goBack }
            }"
          >
            <span class="dot" :style="`--bg: ${itm.color}`">
              {{ itm.porcentaje }}
            </span>
            <span class="label">{{ itm.label }}:</span>
            <span class="valor">{{ itm.value }}</span>
            
          </Item>

          <Item
            v-for="(itm, i) of subGraficaEstructura"
            class="item sub-grafica"
            :key="`link_estructura_${i}`"
            isSubGrafica
            :to="{
              name: 'AnalyticsChart',
              params: { ...itm.subGrafica, goBack }
            }"
          >
            <i class="dot" :style="`--bg: ${itm.color}`" />
            <span class="label">{{ itm.label }}</span>
            
          </Item>
        </div>
      </div>
      <template slot="Empty">
        <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
import colorsS from "./colors.json";
import { CChartPie } from "@coreui/vue-chartjs";
import Item from "./Item.vue";

const colors = JSON.parse(JSON.stringify(colorsS));
export default {
  name: "Pie2",
  components: {
    CChartPie,
    Item
  },
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    estructura: {
      type: Object,
      default: () => ({})
    },
    moneda: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subGraficaEstructura() {
      return (this.estructura?.subGrafica||[]).map(m => {
        const {label, ...subGrafica} = m
        if(Array.isArray(subGrafica.filtros)&&subGrafica.filtros.length===0){
          subGrafica.filtros = {}
        }
        return {
          label,
          subGrafica
        };
      });
    },
    total() {
      return this.data.reduce((v, c) => v + c.valor, 0);
    },
    conceptos() {
      return this.data.map((m, i) => ({
        valor: m.valor,
        label: m.titulo,
        value: this.$formatter(m.valor, this.moneda),
        color: colors[i % colors.length],
        isSubGrafica: m?.subGrafica ? true : false,
        subGrafica: m.subGrafica,
        porcentaje: `${Math.floor(((m.valor||0) / (this.total||1)) * 100)}%`,
      }));
    },
    labels() {
      return this.conceptos.map(m => `${m.label}`);
    },
    datasets() {
      return [
        {
          backgroundColor: this.conceptos.map(m => m.color),
          data: this.conceptos.map(m => m.valor)
        }
      ];
    },
    goBack() {
      return this.$route?.params;
    }
  },
  data() {
    return {
      options: {
        onClick: (evt, item) => {
          if (item.length) {
            const _item_ = this.data[item[0]._index];
            const m = _item_.subGrafica;
            if (m) {
              this.$router.push({
                name: "AnalyticsChart",
                params: { ...m, goBack: this.goBack }
              });
            }
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const valor = this.conceptos[tooltipItem.index].value;
              const label = data.labels[tooltipItem.index];
              return `${label}:  ${valor}`;
            }
          }
        }
      },
    };
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.chart-pie {
  min-height: 400px;
  height: 60vh;
  .conceptos {
    min-width: 200px;
    max-width: 300px;
    .item {
      gap: 5px;
      display: flex;
      font-size: 1rem;
      margin: 10px 5px;
      align-items: center;
      transition: transform 0.25s;
      color: #000;

      &:is(:active, &:visited, &:hover) {
        color: unset;
        text-decoration: none;
      }
      .dot {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: inline-grid;
        place-content: center;
        font-size: 10px;
        color: #fff;
        font-weight: bold;
        background-color: var(--bg, #fff);
        box-shadow: 0px 0px 2px black;
        text-shadow: 0px 0px 2px black;
      }
      .label {
        font-weight: bold;
      }
      .valor {
        justify-self: flex-end;
        text-align: right;
        flex-grow: 1;
      }
      &.sub-grafica:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
